export default defineNuxtRouteMiddleware(async (to, from) => {
  const mainStore = useMainStore()
  const authStore = useAuthStore()

  const { getUser } = useUserService()

  const search = to.query

  if (search.type && search.type === 'app') {
    mainStore.setIsLoadedFromApp(true)

    /*
      Set page layout to empty for challenges pages when in app mode
      This is needed because there's no separate challenges webview yet
      Feel free to remove this once we have a separate challenges webview
    */
    if (to.path.startsWith('/challenge')) {
      setPageLayout('empty')
    }
  }

  if (search.accessToken) {
    let user = { id: search.userId }
    // set the token and user id so that we can request user data
    await authStore.login({ token: search.accessToken, user })

    user = await getUser(search.userId)

    // set the user data
    await authStore.loginSuccess({
      userData: { token: search.accessToken, user },
      rememberMe: true
    })
  }

  // persisting type = app query across pages
  if (from && from.query && from.query.type === 'app' && !to.query.type) {
    return navigateTo({ path: to.path, query: { ...to.query, type: 'app' } })
  }
})
